import React from "react";
import { Link } from "react-router-dom";
import LogoMark from "@/components/LogoMark";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="relative mt-24 overflow-hidden bg-olive-deep text-ivory">
      <div className="tatreez-bg absolute inset-0 opacity-30" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="mb-3 flex items-center gap-2.5">
              <img src="/logo.png" alt="شعار سهول جنين" className="h-10 w-10 rounded-xl object-cover" />
              <div>
                <div className="font-display text-lg font-bold">{t("brand")}</div>
                <div className="text-[11px] text-ivory/70">{t("tagline")}</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-ivory/70">{t("f_desc")}</p>
          </div>

          <div>
            <h4 className="mb-4 font-display font-semibold">{t("f_shop")}</h4>
            <ul className="space-y-2.5 text-sm text-ivory/70">
              <li><Link to="/store?category=olive_oil" className="link-underline">زيت الزيتون</Link></li>
              <li><Link to="/store?category=olives_pickles" className="link-underline">الزيتون والمخللات</Link></li>
              <li><Link to="/store?category=zaatar_spices" className="link-underline">الزعتر والدقة والتوابل</Link></li>
              <li><Link to="/store" className="link-underline">{t("nav_store")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-display font-semibold">{t("f_discover")}</h4>
            <ul className="space-y-2.5 text-sm text-ivory/70">
              <li><Link to="/store?category=honey_jams" className="link-underline">العسل والمربيات</Link></li>
              <li><Link to="/store?category=soap_care" className="link-underline">الصابون والعناية</Link></li>
              <li><Link to="/basket-builder" className="link-underline">{t("nav_basket")}</Link></li>
              <li><Link to="/heritage" className="link-underline">{t("nav_heritage")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-display font-semibold">{t("f_why")}</h4>
            <ul className="space-y-2.5 text-sm text-ivory/70">
              <li>{t("trust1")}</li>
              <li>{t("trust2")}</li>
              <li>{t("trust3")}</li>
              <li>{t("trust4")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-ivory/10 pt-6 text-sm text-ivory/60 md:flex-row">
          <p>© {new Date().getFullYear()} {t("brand")}. {t("f_rights")}</p>
          <p className="text-ivory/50">{t("f_dev")}</p>
        </div>
      </div>
    </footer>
  );
}
